import PropTypes from 'prop-types';
import React from 'react';
import OnsitePing from './onsite_ping';

class GrantsPing extends OnsitePing {
  getTitle() {
    return 'GRANTS UPDATE';
  }

  getBody() {
    return (
      <div className="text">
        We found{' '}
        <strong>
          {this.props.upcomingGrantsCount} {this.props.grantTopicText} grants
        </strong>{' '}
        worth <strong>${this.props.totalValueUSD}</strong> with deadlines in the
        next 3 months.
      </div>
    );
  }

  getUpgradeURL() {
    return $r.upgrade_url({
      feature: 'grants',
      trigger: 'grants-reminder-onsite-ping',
    });
  }

  getButtonText() {
    return 'View Grants and Fellowships';
  }

  getIconClassName() {
    return 'fa fa-money fa-lg icon';
  }
}

GrantsPing.propTypes = {
  upcomingGrantsCount: PropTypes.string.isRequired,
  grantTopicText: PropTypes.string.isRequired,
  totalValueUSD: PropTypes.string.isRequired,
};

export default GrantsPing;
